import { hooks } from "./hookActions"
export let SYSLogin = { hooks }
